export const getBrowser = (state) => state.get('browser');
